import { connect } from 'react-redux';
import moment from 'moment';
import get from 'lodash.get';
import Global from '../../store/global-selectors';
import { markPaid } from '../../store/orders/order-details/orders.details.actions';
import { MarkAsPaidModal } from '../../components/modals/mark-as-paid-modal';

const mapStateToProps = (state, { salesOrderId }) => {
  const amountSummary = Global.selectEntitiesSalesOrderProperty(state, {
    salesOrderId,
    property: 'amountSummary',
  });
  const selectedOrderTotal = parseFloat(get(amountSummary, 'orderTotal.value', 0));
  const selectedOrderTotalPaid = parseFloat(get(amountSummary, 'totalPaid.value', 0));
  const shippingAmountPaid = parseFloat(get(amountSummary, 'shippingPaid.value', 0));
  const userDateFormat = Global.selectUserUserDateFormat(state);
  const paidDateString =
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'paidDateTime',
    }) || moment().format(userDateFormat);
  const defaultCurrency = Global.selectSellerDefaultCurrency(state);
  const orderTotalCurrencyCode = amountSummary.orderTotal.code;
  const shippingAmountPaidCurrencyCode = amountSummary.shippingPaid.code;

  return {
    shippingAmountPaid,
    paidDateString,
    orderTotal: selectedOrderTotal || selectedOrderTotalPaid,
    userDateFormat,
    defaultCurrency,
    orderTotalCurrencyCode,
    shippingAmountPaidCurrencyCode,
  };
};

const mapDispatchToProps = (dispatch, { salesOrderId }) => {
  return {
    markAsPaid: ({ internalNote, paidDateUtc, orderTotal, shippingAmountPaid, orderTotalCurrencyCode, shippingAmountPaidCurrencyCode }) => {
      dispatch(
        markPaid({
          salesOrderId,
          internalNote,
          paidDateUtc,
          orderTotal,
          shippingAmountPaid,
          orderTotalCurrencyCode,
          shippingAmountPaidCurrencyCode,
        }),
      );
    },
  };
};

export const OrderMarkAsPaidModalContainer = connect(mapStateToProps, mapDispatchToProps)(MarkAsPaidModal);
